import { createTheme } from '@mui/material';
import { customPalette } from './layer00';
import { customTypography } from './layer01';



export const theme = createTheme({
  typography: {
    ...customTypography.typography
  },
  palette: {
    ...customPalette.palette
  },
  components: {
    MuiSwitch: {
      styleOverrides: {

        root: {
          '& .Mui-checkedthumb': {
            background: 'red'
          }
        }
      }
    },

    MuiTab: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            fontFamily: 'Lexend',
            textTransform: 'uppercase',
            borderBottom: '.0625rem soild #D1D3D4',
            '&:hover': {
              color: `${theme.palette.primary.main}`,
              content: '\'\''
            },
            '&.Mui-selected': {
              color: theme.palette.primary.darker200,
              fontWeight: theme.typography.fontWeightMedium
            }

          };
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            borderBottom: `1px solid ${theme.palette.gray.light20}`,
            '& .MuiTabs-indicator': {
              backgroundColor: `${theme.palette.primary.main}`,
              height: '.2rem'
            }
          };
        }

      }
    },

    MuiTable: {
      defaultProps: {
        size: 'small'
      }
    },

    MuiTableCell: {
      styleOverrides: {
        head: ({ theme }) => {
          return {
            ...theme.typography.tableHeader,
            textWrap: 'nowrap',
            fontSize: '16px',
            textAlign: 'right'
          };
        },
        body: ({ theme }) => {
          return {
            ...theme.typography.h6,
            color: '#414142',
            textTransform: 'none',
            border: 0,
            fontSize: '16px',
            textAlign: 'right'
          };
        }
      },
      variants: [
        {
          props: {
            variant: 'link'
          },
          style: ({ theme }) => ({
            ...theme.typography.tableCellLink,
            textTransform: 'none',
            border: 0
          })
        },
        {
          props: {
            variant: 'finacialHeader'
          },
          style: ({ theme }) => ({
            ...theme.typography.tableHeader,
            color: theme.palette.gray.light80,
            backgroundColor: theme.palette.primary.light60,
            fontSize: '16px',
            textAlign: 'right'
          })
        },
        {
          props: {
            variant: 'rowLabel'
          },
          style: ({ theme }) => ({
            ...theme.typography.rowLabel

          })
        }

      ]
    },
    MuiFormControl: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            ...theme.typography.formLabel,
            '& .MuiFormLabel-asterisk': {
              color: theme.palette.primary.main
            }
          };
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            ...theme.typography.chatInput,
            color: theme.palette.gray.light60,
            background: theme.palette.gray.light05,
            padding: '0rem .75rem',
            border: `1px solid ${theme.palette.gray.light20}`,
            borderRadius: '.25rem'
          };
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Roboto',
          fontWeight: 'normal'
        }
      }
    },
    MuiChip: {
      variants: [
        {
          props: {
            variant: 'custom'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.success.light,
              color: theme.palette.error.main,
              borderRadius: '0.25rem',
              border: `1px solid ${theme.palette.success.main}`
            };
          }
        },
        {
          props: {
            variant: 'active'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.success.light,
              color: theme.palette.success.main,
              borderRadius: '0.25rem',
              border: `1px solid ${theme.palette.success.main}`
            };
          }
        },
        {
          props: {
            variant: 'warn'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.warning.light,
              color: theme.palette.warning.dark,
              borderRadius: '0.25rem',
              border: `1px solid ${theme.palette.warning.main}`
            };
          }
        },
        {
          props: {
            variant: 'info'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.light,
              color: theme.palette.info.main,
              borderRadius: '0.25rem',
              border: `1px solid ${theme.palette.info.main}`
            };
          }
        },
        {
          props: {
            variant: 'error'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.error.light,
              color: theme.palette.error.main,
              borderRadius: '0.25rem',
              border: `1px solid ${theme.palette.error.main}`
            };
          }
        },
        {
          props: {
            variant: 'disabled'
          },
          style: () => {
            return {
              backgroundColor: '#FAFAFA',
              color: '#B6B7BC',
              borderRadius: '0.25rem',
              border: '1px solid #B6B7BC'
            };
          }
        }
      ]
    },



    MuiButton: {
      styleOverrides: {
        contained: ({ theme }) => {
          return {
            ...theme.typography.button,
            py: '0.5rem',
            px: '1rem'
          };
        },
        outlined: ({ theme }) => {
          return {
            ...theme.typography.button,
            py: '0.5rem',
            px: '1rem',
            borderRadius: '.375rem'
          };
        },
        containedPrimary: ({ theme }) => {
          return {
            ...theme.typography.button,
            py: '0.5rem',
            px: '1rem',
            color: 'white',
            '& .MuiButton-icon': {
              stroke: 'white'
            },
            boxShadow: '0px 2px 2px 0px #00A469'
          };
        },
        containedSecondary: ({ theme }) => {
          return {
            ...theme.typography.button,
            color: '#414142',
            '& .MuiButton-icon': {
              stroke: '#414142'
            }
          };
        },
        textPrimary: ({ theme }) => {
          return {
            ...theme.typography.button,
            '& .MuiButton-icon': {
              stroke: 'white'
            }
          };
        },
        outlinedSecondary: ({ theme }) => {
          return {
            ...theme.typography.button,
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.gray.light80,
            boxShadow: `0px 2px 0px 0px ${theme.palette.gray.light30}`,
            border: `1px solid ${theme.palette.gray.light20}`,
            '& .MuiButton-icon': {
              stroke: '#414142'
            }
          };
        }
      },
      variants: [
        {
          props: {
            variant: 'selectedNav'
          },
          style: {
            backgroundColor: customPalette.primaryColor.darker200,
            color: customPalette.gray.light05,
            paddingTop: '.75rem',
            paddingBottom: '.75rem',
            height: '2.5rem',
            borderRadius: '.75rem'
          }
        },
        {
          props: {
            variant: 'notSelectedNav'
          },
          style: {
            backgroundColor: 'white',
            color: customPalette.gray.light60,
            paddingTop: '.75rem',
            paddingBottom: '.75rem',
            height: '2.5rem',
            borderRadius: '.75rem'
          }
        },
        {
          props: {
            variant: 'chatCategorySelect'
          },
          style: {
            stroke: customPalette.primaryColor.main,
            textWrap: 'nowrap',
            backgroundColor: customPalette.primaryColor.light80,
            color: customPalette.primaryColor.darker200,
            paddingTop: '.75rem',
            paddingBottom: '.75rem',
            height: '2.5rem',
            borderRadius: '.5rem',
            ':hover': {
              backgroundColor: 'white !important'
            }
          }
        }
      ]
    },

    MuiListItemButton: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          borderRadius: '12px',
          '&.Mui-selected': {
            backgroundColor: '#1E3E30'
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#1E3E30'
          }
        }
      }
    },

    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: 'Lexend',
          textTransform: 'none',
          fontSize: '15px',
          fontWeight: 500,
          color: '#67726D',

          '.Mui-selected &': {
            color: 'white'
          }
        }
      }
    },

    MuiPopper: {
      defaultProps: {
        placement: 'top-start',
        sx: {
          zIndex: 1500,
          p: 1,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          boxShadow: 3
        },
        modifiers: [{
          name: 'offset',
          options: {
            offset: [
              0,
              8
            ]
          }
        }]
      }
    }
  }
});
